import { MOUSE } from "three/src/constants";
import { Raycaster } from "three/src/core/Raycaster";
import { Box3 } from "three/src/math/Box3";
import { degToRad } from "three/src/math/MathUtils";
import { Matrix4 } from "three/src/math/Matrix4";
import { Quaternion } from "three/src/math/Quaternion";
import { Sphere } from "three/src/math/Sphere";
import { Spherical } from "three/src/math/Spherical";
import { Vector2 } from "three/src/math/Vector2";
import { Vector3 } from "three/src/math/Vector3";
import { Vector4 } from "three/src/math/Vector4";
import { MathUtils } from "three/src/Three";

export const THREE_SUBSET = {
  MOUSE     : MOUSE,
  Vector2   : Vector2,
  Vector3   : Vector3,
  Vector4   : Vector4,
  Quaternion: Quaternion,
  Matrix4   : Matrix4,
  Spherical : Spherical,
  Box3      : Box3,
  Sphere    : Sphere,
  Raycaster : Raycaster,
  MathUtils : {
    DEG2RAD: MathUtils.DEG2RAD,
    clamp: MathUtils.clamp,
  },
};

export const SectorTileWidth = 1186.0;
export const SectorTileHeight = 1341.762;

export const SectorR = SectorTileWidth / 2;
export const SectorS = SectorR / Math.cos(degToRad(30));
export const SectorH = (SectorTileHeight - SectorS) / 2;
export const SectorHS = SectorH + SectorS;

